export default "__VITE_ASSET__CZ12Nud4__"